function safeDiv(n: number | undefined, d: number | undefined, percent : boolean = true) {
  return ((d ? (n || 0) / d : 0) * (percent ? 100 : 1)).toFixed(1);
}

function formatToMinutesSeconds(seconds: number) {
  return `${Math.floor(seconds / 60)}:${(Math.floor(seconds % 60)).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}`;
}

export { safeDiv, formatToMinutesSeconds };